import React, { useState, useEffect } from 'react';
import { CirclePack } from '../circlePack/index';
import { NonIdealState } from '@blueprintjs/core';
import { extent } from 'd3';
import { NO_DATA_MESSAGE } from 'widgets/chartUtils';

/**
 * ChartWrapper for the Custom Circle Pack widget.
 *
 * @param widgetConfiguration
 * @param dimensions
 * @param data
 * @returns {*}
 * @constructor
 */
export function CustomPackWrapper({ getColorScale, widgetConfiguration, dimensions, data, noDataMessage=NO_DATA_MESSAGE }) {
	const [convertedData, setConvertedData] = useState(null);

	useEffect(() => {
		// the data is null or in the wrong shape and we exit
		if (!data || !Array.isArray(data?.entries)) return;

		// empty data is "valid"
		if (data.entries?.length === 0) {
			setConvertedData([]);
		}

		const converted = {
			children: data.entries,
		};

		setConvertedData(converted);
	}, [data]);

	getColorScale.domain(extent(data.entries.map(d => d.count)));

	return convertedData ? (
		<CirclePack getColorScale={getColorScale} data={convertedData} dimensions={dimensions} showTopLabelsOnly={!widgetConfiguration?.showAllLabels} />
	) : (
		<NonIdealState
			title="No Data Found"
			icon="graph-remove"
			description={noDataMessage}
		/>
	);
}
